import React from 'react';

import {
  BoldText,
  ClauseText,
  DangerText,
  InfoText,
} from './Components/ContractText';

interface Props {
  homeinspectionNegotiationDays?: number;
}

const MaintenanceAndRisk = ({ homeinspectionNegotiationDays }: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Maintenance and Risk of Loss
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Seller will maintain the Property including, but not limited to,
          structures, grounds, fixtures, appliances, and personal property
          specifically listed in this Agreement in its present condition, normal
          wear and tear excepted.
        </li>
        <li>
          If any part of the Property included in the sale fails before
          settlement, Seller will
          <ol className="ml-4 list-decimal">
            <li>
              <ClauseText>Repair or replace</ClauseText> that part of the
              Property before settlement,
            </li>
            <li>
              Provide <ClauseText>prompt written notice</ClauseText> to Buyer of
              Seller’s decision to
              <ul className="ml-4 list-disc">
                <li>
                  Credit Buyer at settlement for the fair market value of the
                  failed part of the Property, as acceptable to the mortgage
                  lender,
                </li>
                <li>
                  Not repair or replace the failed part of the Property, and not
                  credit Buyer at settlement for the fair market value of the
                  failed part of the Property.
                </li>
              </ul>
            </li>
            <li>
              If Seller does not repair or replace the failed part of the
              Property or agree to credit Buyer for its fair market value, or if
              Seller fails to notify Buyer of Seller’s choice, Buyer will notify
              Seller in writing within {homeinspectionNegotiationDays} days or
              before Settlement Date, whichever is earlier, that Buyer will:
              <ul className="ml-4 list-disc">
                <li>
                  <ClauseText>
                    Accept the Property and agree to the Release clause of this
                    Agreement
                  </ClauseText>
                </li>
                <li>
                  Terminate this Agreement by written notice to Seller, with all
                  deposit monies returned to Buyer according to the terms of
                  this Agreement.
                </li>
              </ul>
            </li>
            <li>
              If Buyer fails to respond within the 5 days or fails to terminate
              this Agreement by written notice to Seller within that time, Buyer
              will{' '}
              <ClauseText>
                accept the Property and agree to the Release clause of this
                Agreement
              </ClauseText>
              .
            </li>
          </ol>
        </li>
        <li>
          Seller bears the risk of loss from fire or other casualties until
          settlement. If any property included in this sale is destroyed and not
          replaced prior to settlement, Buyer will either:
          <ul className="ml-4 list-disc">
            <li>
              Accept the Property in its then current condition together with
              the proceeds of any insurance recovery obtainable by Seller , OR
            </li>
            <li>
              Terminate this Agreement by written notice to Seller, with all
              deposit money returned to Buyer according to the terms of this
              Agreement.
            </li>
          </ul>
        </li>
      </ol>
    </div>
  );
};

export default MaintenanceAndRisk;
